import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  EmergencyModeEntered,
  enterEmergencyMode,
  EnterEmergencyMode,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEnterEmergencyMode = (
  options: UseMutationOptions<
    EmergencyModeEntered,
    unknown,
    EnterEmergencyMode,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation<
    EmergencyModeEntered,
    unknown,
    EnterEmergencyMode,
    unknown
  >({
    mutationFn: async (params) =>
      extractData(
        enterEmergencyMode({
          body: params,
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['emergencyMode'] });
      options.onSuccess?.(...args);
    },
  });
};
